<script>
import { mapActions } from "vuex";
import i18n from "@/plugins/i18n";
import SustainfinityTable from "../../../components/SustainfinityTable.vue";

export default {
  name: "Prompts",
  components: {
    SustainfinityTable,
  },
  data() {
    return {
      elementPromptsFields: [
        {
          key: "sust_element_name",
          label: i18n.t("additionalSettings.prompts.header.sust_element_name"),
          width: 3,
        },
        {
          key: "element_prompt_text",
          label: i18n.t("additionalSettings.prompts.header.prompt_text"),
          width: 9,
        },
        {
          key: "created_on",
          label: i18n.t("additionalSettings.prompts.header.created_on"),
          width: 1,
        },
        {
          key: "c_fullname",
          label: i18n.t("additionalSettings.prompts.header.created_by"),
          width: 1,
        },
        {
          key: "updated_on",
          label: i18n.t("additionalSettings.prompts.header.updated_on"),
          width: 1,
        },
        {
          key: "u_fullname",
          label: i18n.t("additionalSettings.prompts.header.updated_by"),
          width: 1,
        },
        { 
          key: "edit", 
          label: i18n.t("additionalSettings.prompts.header.edit"),
          width: 1,
        },
        {
          key: "delete",
          label: i18n.t("additionalSettings.prompts.header.delete"),
          width: 1,
        },
      ],
      sustPromptsFields: [
        {
          key: "sust_report_prompt_header",
          label: i18n.t("additionalSettings.prompts.header.sust_report_name"),
          width: 3,
        },
        {
          key: "sust_report_prompt_text",
          label: i18n.t("additionalSettings.prompts.header.prompt_text"),
          width: 9,
        },
        {
          key: "created_on",
          label: i18n.t("additionalSettings.prompts.header.created_on"),
          width: 1,
        },
        {
          key: "c_fullname",
          label: i18n.t("additionalSettings.prompts.header.created_by"),
          width: 1,
        },
        {
          key: "updated_on",
          label: i18n.t("additionalSettings.prompts.header.updated_on"),
          width: 1,
        },
        {
          key: "u_fullname",
          label: i18n.t("additionalSettings.prompts.header.updated_by"),
          width: 1,
        },
        { 
          key: "edit", 
          label: i18n.t("additionalSettings.prompts.header.edit"),
          width: 1,
        },
        {
          key: "delete",
          label: i18n.t("additionalSettings.prompts.header.delete"),
          width: 1,
        },
      ],

      promptsItems: [],
      loadingPromptsItems: false,
      promptText: "",
      elementItems: [],
      selectedPromptID: "",
      
      selectedElementItem : "",
      selectedSustItem : "",

      selectedElementItemUpdate : "",
      selectedSustItemUpdate : "",

      createElementPromptsModal: false,
      createSustPromptsModal: false,
      
      elementPromptsTextUpdate: "",
      sustPromptTextUpdate: "",

      updateElementPromptsModal: false,
      deleteElementPromptsModal: false,
      
      updateSustPromptsModal: false,
      deleteSustPromptsModal: false,
      
      elementPrompts: [],
      sustReportPrompts: [],

      createElementModal: false,
      createSustModal: false,

      allElementPrompts: [],
      allSustReportPrompts: [],

      selectedTab: 'elements',
    };
  },
  mounted() {
    this.allPrompts();

    this.loadingPromptsItems = true;
    setTimeout(() => {
      this._getElementPrompts();
      this._getSustPrompts();
      this.loadingPromptsItems = false;
    }, 1000);
  },
  computed: {
    elementItemsWithRowNumbers() {
      return this.elementPrompts.map((item, index) => {
        return { ...item, rowNumber: index + 1 };
      });
    },
    sustItemsWithRowNumbers() {
      return this.sustReportPrompts.map((item, index) => {
        return { ...item, rowNumber: index + 1 };
      });
    },
  },
  methods: {
    ...mapActions("additionalsettings", [
      "getElementPrompts",
      "createElementPrompt",
      "updateElementPrompt",
      "deleteElementPrompt",
      
      "getSustPrompts",
      "createSustPrompt",
      "updateSustPrompt",
      "deleteSustPrompt",
      
      "getElement",
    ]),
    ...mapActions("reports", ["getReportHeaders"]),
    getAllElements() {
      this.elementItems = [];
      const params = {
        created_by: this.$user.user_id,
        is_deleted: false,
      };
      this.getElement(params)
        .then((res) => {
          res.data.forEach((element) => {
            this.elementItems.push(element);
          });
        })
        .catch(({ response }) => {
          this.$notify('error', response.data.messageName);
        })
    },
    promptsByCompanyId() {
      this.promptsItems = [];
      this.loadingPromptsItems = true;
      const params = {
        company_id: this.$user.company_id,
        created_by: this.$user.user_id,
        is_deleted: false,
      };
      this.getPromptsByCompanyId(params)
        .then((res) => {
          res.data.forEach((element) => {
            this.promptsItems.push(element);
          });
        })
        .catch(({ response }) => {
          this.$notify('error', response.data.messageName);
        })
        .finally(() => {
          this.loadingPromptsItems = false;
        });
    },
    createPromptOK() {
      this.loadingPromptsItems = true;
      const params = {
        sust_element_id: this.selectedElementItem,
        company_id: this.$user.company_id,
        prompt_text:  this.promptText,
        created_by: this.$user.user_id,
        is_default: true
      };
      this.createPrompt(params)
        .then((res) => {
          this.promptsByCompanyId();
          this.$notify('success', res.data.messageName);
        })
        .catch(({ response }) => {
          this.$notify('error', response.data.messageName);
        })
        .finally(() => {
          this.loadingPromptsItems = false;
        });
    },
    resetCreateModal() {
      (this.promptText = ""), (this.selectedElementItem = "");
    },

    openCreatePopup(tab) {
      if (this.selectedTab !== tab) {
        this.selectedTab = tab;
      }

      this.$refs.createPopup.openPopup();
    },

    clickItem(e) {
      if (e) {
        if (!e.event) {
          console.error('No event data emitted from the table!');  
        } else if (e.event === 'edit') {
          this.openUpdateDialog(e.item);
        } else if (e.event === 'delete') {
          this.openDeleteDialog(e.item);
        } else {
          console.error('Invalid event emitted from the table: ', e.event);
        }
      } else {
        console.error('No event data emitted from the table!');
      }
    },

    openUpdateDialog(item) {
      if (this.selectedTab === 'elements') {
        this.elementPromptsTextUpdate = item.element_prompt_text;
        this.selectedElementItem = item.sust_element_id;
        this.selectedPromptID = item.element_prompt_id;
        this.$refs.updatePopup.openPopup();
      } else {
        this.sustPromptTextUpdate = item.sust_report_prompt_text;
        this.selectedPromptID = item.sust_report_prompt_id;
        this.$refs.updatePopup.openPopup();
      }
    },

    openDeleteDialog(item) {
      if (this.selectedTab === 'elements') {
        this.selectedPromptID = item.element_prompt_id;
        this.$refs.deletePopup.openPopup();
      } else {
        this.selectedPromptID = item.sust_report_prompt_id;
        this.$refs.deletePopup.openPopup();
      }
    },

    allPrompts(){
      let params = {
        report_type: "sustainability_report",
        is_deleted: false
      }
      this.getReportHeaders(params)
        .then(res => {
          const data = res.data;

          data.forEach(element => {
            if (element.report_header_element_id == null){
              this.allSustReportPrompts.push(element);
            }
            else {
              this.allElementPrompts.push(element);
            }
          });
        })
    },

    // ELEMENT //
    _getElementPrompts() {
      const params = {
        created_by: 81,
        is_deleted: false
      }
      this.getElementPrompts(params)
        .then( res => {
          this.elementPrompts = res.data;

          // calculate the names of elements from all the data
          this.elementPrompts.forEach(item => {
            const element = this.allElementPrompts.find(x => x.report_header_element_id == item.sust_element_id);
            if (element) {
              item["sust_element_name"] = element.report_header_name;
            } else {
              item["sust_element_name"] = "empty_element";
            }
          });
        })
        .catch(({ response }) => {
          this.$notify('error', response.data.messageName);
        })
    },
    _createElementPrompt() {
      const params = {
        sust_element_id: this.selectedElementItem,
        company_id: this.$user.company_id,
        element_prompt_text: this.promptText,
        is_default: true,
        created_by: 81
      }
      this.createElementPrompt(params)
        .then( res => {
          this.$notify('success', res.data.messageName);
        })
        .catch(({ response }) => {
          this.$notify('error', response.data.messageName);
        })
        .finally(() => {
          this._getElementPrompts();
        })
    },
    _updateElementPrompt() {
      const params = {
        prompt_id: this.selectedPromptID,

        element_prompt_text: this.elementPromptsTextUpdate,
        updated_by: 81
      }
      this.updateElementPrompt(params)
        .then( res => {
          this.$notify('success', res.data.messageName);
        })
        .catch(({ response }) => {
          this.$notify('error', response.data.messageName);
        })
        .finally(() => {
          this._getElementPrompts();
        })
    },
    _deleteElementPrompt() {
      const params = {
        element_prompt_id: this.selectedPromptID
      }
      this.deleteElementPrompt(params)
        .then( res => {
          this.$notify('success', res.data.messageName);
        })
        .catch(({ response }) => {
          this.$notify('error', response.data.messageName);
        })
        .finally(() => {
          this._getElementPrompts();
        })
    },

    // SUST REPORT //
    _getSustPrompts() {
      const params = {
        created_by: 81,
        is_deleted: false
      }
      this.getSustPrompts(params)
        .then( res => {
          this.sustReportPrompts = res.data;

          // calculate the names of sust reports
          this.sustReportPrompts.forEach(element => {
            const matchingElement = this.allSustReportPrompts.find( item => item.report_header_abbreviation == element.sust_report_prompt_name);
            if (matchingElement) {
              element["sust_report_prompt_header"] = matchingElement.report_header_name;
            } else {
              element["sust_report_prompt_header"] = "empty_sust_report_header";
            }
          });
        })
        .catch(({ response }) => {
          this.$notify('error', response.data.messageName);
        })
    },
    _createSustPrompt() {
      const params = {
        company_id: this.$user.company_id,
        sust_report_prompt_text: this.promptText,
        sust_report_prompt_name: this.selectedSustItem,
        is_default: true,
        created_by: 81
      }
      this.createSustPrompt(params)
        .then( res => {
          this.$notify('success', res.data.messageName);
        })
        .catch(({ response }) => {
          this.$notify('error', response.data.messageName);
        })
        .finally(() => {
          this._getSustPrompts();
        })
    },
    _updateSustPrompt() {
      const params = {
        prompt_id: this.selectedPromptID,

        sust_report_prompt_text: this.sustPromptTextUpdate,
        updated_by: 81
      }
      this.updateSustPrompt(params)
        .then( res => {
          this.$notify('success', res.data.messageName);
        })
        .catch(({ response }) => {
          this.$notify('error', response.data.messageName);
        })
        .finally(() => {
          this._getSustPrompts();
        })
    },
    _deleteSustPrompt() {
      const params = {
        sust_report_prompt_id: this.selectedPromptID
      }
      this.deleteSustPrompt(params)
        .then( res => {
          this.$notify('success', res.data.messageName);
        })
        .catch(({ response }) => {
          this.$notify('error', response.data.messageName);
        })
        .finally(() => {
          this._getSustPrompts();
        })
    },
  },
};
</script>

<template>
  <div>
    <button
      class="sust-btn sust-btn-green"
      style="float: right; margin-left: 1em;"
      @click="openCreatePopup('sust_reports')"
    >
      {{ $t("additionalSettings.prompts.createSustPrompts") }}
    </button>
    <button
      class="sust-btn sust-btn-green"
      style="float: right; margin-left: 1em;"
      @click="openCreatePopup('elements')"
    >
      {{ $t("additionalSettings.prompts.createElementPrompts") }}
    </button>
    <br><br>

    <div class="element-report-prompts-tabs">
      <button 
        @click="() => selectedTab = 'elements'"
        :class="{'selected-tab-btn': selectedTab === 'elements'}"
      >
        Elements
      </button>
      <button 
        @click="() => selectedTab = 'sust_reports'"
        :class="{'selected-tab-btn': selectedTab === 'sust_reports'}"
      >
        Sust Reports
      </button>
    </div>

    <br>
    <sustainfinity-table 
      :headers="selectedTab === 'elements' ? elementPromptsFields : sustPromptsFields"
      :items="selectedTab === 'elements' ? elementPrompts : sustReportPrompts"
      :iterator="selectedTab === 'elements' ? 'element_prompt_id' : 'sust_report_prompt_id'"
      :loading="loadingPromptsItems"
      @btnClick="clickItem($event)"
    />

    <sust-popup
      ref="createPopup"
      size="lg"
      :title="`Create ${selectedTab === 'elements' ? 'Element' : 'Sust Report'} Prompt`"
      @onHide="resetCreateModal()"
      @ok="selectedTab === 'elements' ? _createElementPrompt() : _createSustPrompt()"
    >
      <div class="additional-settings-popup-body">
        <div class="full-size" v-if="selectedTab === 'elements'">
          <label for="input">
            {{ $t('additionalSettings.prompts.header.sust_element_name') }}
          </label>
          <select name="input" v-model="selectedElementItem">
            <option v-for="item in allElementPrompts" 
              :key="item.report_header_element_id"
              :value="item.report_header_element_id"
            >
              {{ item.report_header_name }}
            </option>
          </select>
        </div>
        
        <div class="full-size" v-else-if="selectedTab === 'sust_report'">
          <label for="input">
            {{ $t('additionalSettings.prompts.header.sust_element_name') }}
          </label>
          <select name="input" v-model="selectedSustItem">
            <option v-for="item in allSustReportPrompts" 
              :key="item.report_header_abbreviation"
              :value="item.report_header_abbreviation"
            >
              {{ item.report_header_name }}
            </option>
          </select>
        </div>

        <div class="full-size">
          <label for="input">
            {{ $t('additionalSettings.prompts.header.prompt_text') }}
          </label>
          <textarea name="input" rows="20"
            v-model="promptText"
          >
          </textarea>
        </div>
      </div>
    </sust-popup>

    <sust-popup
      ref="updatePopup"
      size="lg"
      :title="`Update ${selectedTab === 'elements' ? 'Element' : 'Sust Report'} Prompt`"
      @ok="selectedTab === 'elements' ? _updateElementPrompt() : _updateSustPrompt()"
    >
      <div class="additional-settings-popup-body">
        <div class="full-size">
          <label for="input">
            {{ $t('additionalSettings.prompts.header.prompt_text') }}
          </label>
          <textarea 
            v-if="selectedTab === 'elements'"
            name="input" rows="20"
            v-model="elementPromptsTextUpdate"
          >
          </textarea>
          <textarea 
            v-else-if="selectedTab === 'sust_reports'"
            name="input" rows="20"
            v-model="sustPromptTextUpdate"
          >
          </textarea>
        </div>
      </div>
    </sust-popup>

    <sust-popup
      ref="deletePopup"
      size="md"
      :title="`Delete ${selectedTab === 'elements' ? 'Element' : 'Sust Report'} Prompt`"
      @ok="selectedTab === 'elements' ? _deleteElementPrompt() : _deleteSustPrompt()"
    >
      <div class="additional-settings-popup-body">
        <div class="full-size">
          {{ $t("additionalSettings.prompts.deletePromptsTitle") }}
        </div>
      </div>
    </sust-popup>
  </div>
</template>

<style lang="scss" scoped>
.element-report-prompts-tabs {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  border-radius: 100px;
  border: thin solid var(--sustainfinity-navy);
  overflow: hidden !important;

  > button {
    width: 100%;
    text-align: center;
    font-weight: bold;
    background-color: var(--sustainfinity-navy);
    color: whitesmoke;
    
    border: 0 !important;
    outline: 0 !important;

    transition: background-color 150ms;

    &:hover {
      background-color: var(--sustainfinity-navy--hover);
    }

    &:focus {
      background-color: var(--sustainfinity-navy--hover);
    }

    &:first-of-type {
      border-right: thin solid whitesmoke !important;
    }
  }

  .selected-tab-btn {
    background-color: whitesmoke !important;
    color: var(--sustainfinity-navy) !important;
    pointer-events: none !important;
  }
}
</style>

<style scoped>
  .--no-border {
    border: none !important;
  }
</style>